import { RMLine } from 'business/models/CustomModels';

interface Props {
  rectX: number;
  rectY: number;
  rectWidth: number;
  rectHeight: number;
  gap?: number;
}

const getSlantyLinesCoordinates = (props: Props): RMLine[] => {
    const { rectX, rectY, rectWidth, rectHeight, gap } = props
    let startX = rectX;
    let endX = rectX - rectWidth / 6;
    const gapInLines = gap ? gap : rectWidth / 3;

    const calculateLineEndpoints = (): RMLine => {
        startX = startX + gapInLines;
        endX = endX + gapInLines;
        const startY = rectY;
        const endY = rectY + rectHeight;

        return {startX, startY, endX, endY, strokeWidth: 0.7};
    };

    return [1, 2, 3, 4, 5, 6].map(calculateLineEndpoints)
}

export default getSlantyLinesCoordinates